module.exports = __webpack_public_path__ + "static/media/solution-img3.b41b6f9c.png";